enum PRODUCT_RETURN_REASON_CODE {
  DEFECTIVE_ITEM = 'DEFECTIVE_ITEM',
  DAMAGED_PACKAGE = 'DAMAGED_PACKAGE',
  SIZE_OR_FIT = 'SIZE_OR_FIT',
  STYLE = 'STYLE',
  INCORRECT_PRODUCT = 'INCORRECT_PRODUCT',
  MATERIAL = 'MATERIAL',
  COLOR = 'COLOR',
  ORDERED_EXTRA = 'ORDERED_EXTRA',
  SHIPPING_DELAY = 'SHIPPING_DELAY',
  CHANGED_MIND = 'CHANGED_MIND',
  OTHER = 'OTHER',
}

export default PRODUCT_RETURN_REASON_CODE
